import { render, staticRenderFns } from "./CustomQuestions.vue?vue&type=template&id=6670f525"
import script from "./CustomQuestions.vue?vue&type=script&lang=ts"
export * from "./CustomQuestions.vue?vue&type=script&lang=ts"
import style0 from "./CustomQuestions.vue?vue&type=style&index=0&id=6670f525&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports